import React from "react";
import { Task } from "../types";

interface TaskNameDisplayProps {
    task: Task;
    showRegion?: boolean;
    nameClassName?: string;
    regionClassName?: string;
    className?: string;
}

export const TaskNameDisplay: React.FC<TaskNameDisplayProps> = ({
    task,
    showRegion = true,
    nameClassName = "",
    regionClassName = "",
    className = "",
}) => {
    const taskName = task.node?.display || task.more?.name || "Untitled";
    const region = task.node?.piv_level1 || "—";

    return (
        <div className={className}>
            <p
                className={`font-medium text-slate-900 text-sm leading-tight truncate ${nameClassName}`}
            >
                {taskName}
            </p>
            {showRegion && (
                <p
                    className={`text-xs text-slate-500 truncate ${regionClassName}`}
                >
                    {region}
                </p>
            )}
        </div>
    );
};
